import Api from './base.api';
import md5 from 'md5';

interface IKidsApi {
  fetchList: (type: string) => Promise<any>;
  add: (params: { fullName: string; project: string }) => Promise<any>;
  edit: (params: { teacherName: string; id: number | string }) => Promise<any>;
  delete: (id: string) => Promise<any>;
}

class KidsApi extends Api implements IKidsApi {
  fetchList = (projectId: string) =>
    this.request(`kids?projectId=${projectId}`);

  add = (params: { fullName: string; project: string }) =>
    this.request('kids/add', {
      method: 'post',
      body: JSON.stringify(params),
    });

  addByQr = async (params: any) => {
    const currentDate = new Date();
    const dayString = currentDate.getUTCDate().toString();
    const publicToken = `public_token_${dayString}`;
    const hashedToken = md5(publicToken);

    return this.request('kids/add_by_qrcode', {
      method: 'post',
      body: JSON.stringify(params),
    }, hashedToken);
  };

  edit = (params: any) =>
    this.request(`kids/${params.id}/edit`, {
      method: 'post',
      body: JSON.stringify(params),
    });

  delete = (id: string) =>
    this.request(`kids/${id}/remove`, {
      method: 'delete',
    });
}

export default new KidsApi();
